import type { IOAuth2Config } from 'library';

export const oauth2Config: IOAuth2Config = {
  clientId: import.meta.env.VITE_OAUTH2_CLIENT_ID as string,
  authUrl: import.meta.env.VITE_OAUTH2_AUTH_URL as string,
  tokenUrl: import.meta.env.VITE_OAUTH2_TOKEN_URL as string,
  redirectUri: import.meta.env.VITE_OAUTH2_REDIRECT_URI as string,
  scope: import.meta.env.VITE_OAUTH2_SCOPE as string,
  responseType: import.meta.env.VITE_OAUTH2_RESPONSE_TYPE as string,
  codeChallengeMethod: import.meta.env
    .VITE_OAUTH2_CODE_CHALLENGE_METHOD as string,
  grantType: import.meta.env.VITE_OAUTH2_GRANT_TYPE as string,
};
